import React, { useCallback, useMemo, useState, useEffect, useRef } from 'react'
import {
  IconSearch,
  IconLesson,
  IconOptions,
  IconDolarRefresh,
  DropDownNew,
  DropDownItem,
  IconStarActive,
  IconCircleDolar,
  useWindowDimensions,
  IconFilter,
  IconTime,
  ToolTipInfo,
  IconArrowDown
} from '@Knowledge-OTP/znk-ui-components'
import Skeleton from 'react-loading-skeleton'
import * as moment from 'moment'
import 'moment-timezone'
import StatusesFilter from './Filters/Statuses'
import StartDateFilter from '../Plans/Filters/StartDateBadge'
import TypesFilter from './Filters/Types'
import ParentsFilter from './Filters/Parent'
import StudentsFilter from './Filters/Students'
import CreditsFilter from './Filters/Credits'
import TagsFilter from './Filters/Tags'
import './index.css'
import NewPaymentItem from './Payments/new'
import NewInvoice from './Invoices/new'
import { useDispatch, useSelector } from 'react-redux'
import ViewInvoice from './Invoices/view'
import ProcessInvoice from './Invoices/process'
import EditInvoice from './Invoices/edit'
import formatNumber from '../../utils/formatNumber'
import { isEqual } from 'lodash'
import { InputGroup, TabPane, TabContent } from 'reactstrap'
import useTranslation from '../../i18n/useTranslation'
import Pagination from '../../common/Pagination'
import ResetFiltersButton from '../../common/ResetFiltersButton'
import { gql, useQuery } from '@apollo/client'
//MAILS LIST
import useModalEmailsList from '../../common/ModalEmailsList/useModalEmailsList'
import OptionsEmailsAndDownloads from '../../common/ModalEmailsList/Components/Options'
import NoAuthorize from '../../common/NoAuthorize'
import NewActionButton from '../../common/NewActionButton'
import useSendSummaryEmail from './Invoices/SendSummaryEmail/useSendSummaryEmail'
// import useCopyInvoiceLink from './CopyInvoiceLink'
import ModalFilterMobile from './Filters/ModalFilterMobile'
import normalizeNumber from '../../utils/normalizeNumber'
import StatementAccount from './StatementAccount'
import { getFirstNonEmptyId, studentBelongsToParent } from './StatementAccount/statementAccountUtils'
const baseStatuses = ['pendingPayment', 'paid', 'unPaid', 'canceled', 'refunded']
const filterForStatus = {
  pendingPayment: 'unPaid',
  paid: 'paid',
  unPaid: 'pendingPayment',
  canceled: 'canceled',
  refunded: 'refunded',
  draft: 'draft'
}

const manualTypes = ['livePrepManual', 'counselingManual']
const manualCategoryMap = {
  livePrepManual: 'livePrep',
  counselingManual: 'counseling'
}
const baseTypes = ['livePrep', 'counseling', ...manualTypes]

const PaymentsViews = props => {
  const dispatch = useDispatch()
  const { translate } = useTranslation()
  const { open: openSendSummaryEmail } = useSendSummaryEmail()
  const [txtSearch, setTxtSearch] = useState('')
  const [activePage, setActivePage] = useState(1)
  // const { copyInvoiceLink } = useCopyInvoiceLink()
  const { breakWidth } = useWindowDimensions()
  //eslint-disable-next-line
  const [shortcuts, setShortcuts] = useState({
    currentCicle: true,
    pending: false,
    upcomming: false,
    paidOut: false,
    cancelled: false,
    draft: false,
    all: false
  })
  const baseQuery = {
    limit: 20,
    next: '',
    previous: '',
    sortField: 'from',

    category: [],
    parentUserId: [],
    userId: [], // ['5f4d0ec04fcf1942978b4de5'],
    searchString: undefined,

    status: [],
    otherStatuses: [],
    from: undefined,
    to: undefined,
    current: shortcuts.currentCicle,
    pending: shortcuts.pending,
    tagsId: [],
  }
  const getDefaultQueryByShortcuts = (newShortcuts) => {
    const statusShort = newShortcuts.all
      ? ['pendingPayment', 'paid', 'unPaid', 'draft', 'canceled']
      : newShortcuts.currentCicle
        ? ['pendingPayment', 'paid', 'unPaid']
        : newShortcuts.paidOut
          ? ['paid']
          : newShortcuts.pending
            ? ['unPaid']
            : newShortcuts.cancelled
              ? ['canceled']
              : ['draft']
    return {
      ...baseQuery,
      status: statusShort,
      from: newShortcuts.currentCicle ? moment().clone().startOf('month').format('YYYY-MM-DD') + 'T00:00:00.000Z' : undefined,
      to: newShortcuts.currentCicle ? moment().clone().endOf('month').format('YYYY-MM-DD') + 'T23:59:59.999Z' : undefined,
      current: newShortcuts.currentCicle,
      pending: newShortcuts.pending
    }
  }

  const { staffInfo, timezone: currentTimezone } = useSelector((state) => state.user)
  const isPermited = staffInfo?.permissions?.filter(e => e.isPermited).map(per => { return per.tag }).includes('invoices');
  const isTotalPermited = staffInfo?.permissions?.filter(e => e.isPermited).find(({ tag }) => tag === 'invoices').subpermissions.filter(({ isPermited }) => isPermited).map(({ tag }) => tag).includes("invoices-total")

  const modalData = useSelector((state) => state.modal.payments.viewInvoice)
  const { isOpen } = modalData

  const setCurrentShortcut = (shortcutKey) => {
    const newShortcut = {
      currentCicle: false,
      pending: false,
      upcomming: false,
      paidOut: false,
      cancelled: false,
      draft: false,
      all: false
    }
    newShortcut[shortcutKey] = true
    setShortcuts(newShortcut)
  }
  const resetShortcuts = () => {
    setShortcuts({
      currentCicle: true,
      pending: false,
      upcomming: false,
      paidOut: false,
      cancelled: false,
      draft: false,
      all: false
    })
  }

  //ACTUALIZACIÓN AL CLICKEAR UN SHORTCUT
  const defaultQuery = useMemo(
    () => {
      return getDefaultQueryByShortcuts(shortcuts)
      //eslint-disable-next-line
    }, [shortcuts]
  )
  useEffect(() => {
    setFilter(defaultQuery)
    //eslint-disable-next-line
  }, [defaultQuery])


  const [query, setQuery] = useState({ ...defaultQuery })

  const [studentState, setStudentState] = useState({ students: [], loading: true, error: null })
  const { students: statementStudents, loading: studentsLoading, error: studentsError } = studentState
  const parentUserIds = query?.parentUserId
  const selectedUserIds = query?.userId
  const effectiveParentUserId = useMemo(() => getFirstNonEmptyId(parentUserIds), [parentUserIds])

  const searchRef = useRef(null)
  useEffect(() => {
    //actualiza campo de busqueda
    if (!query.searchString || query.searchString?.length === 0) {
      // vacia el campo de busqueda
      if (searchRef?.current) searchRef.current.value = "";
    }
    setTxtSearch(query.searchString)
  }, [query.searchString])

  const canReset = (query) => {
    return !isEqual(query, defaultQuery)
  }

  const resetFilters = () => {
    setFilter({ ...defaultQuery })
  }

  const paymentQueryResult = `
              id
              status
              isRefunded
              hasNegativePayment
              category
              invoiceNumber
              taxFee
              user {
                id
                firstName
                lastName
              }
              processedTimes
              invoiceNumber
              createdAt
              updatedAt
              from
              to
              paymentItemIds
              lastProcessedAt
              amount
              amountPaid
              isManual
              paymentItems {                
                ... on PlanPaymentItem {
                  planId
                  id
                }
                ... on LessonPaymentItem {
                  lessonId
                  id
                }
                ... on EducatorPaymentItem {
                  id
                }
                ... on CustomPaymentItem {
                  id
                }
              }
              processInVoiceLater {
                processDate
              }
              `
  const { data, loading: loadInvoices, refetch } = useQuery(
    gql`query(
        $limit: Int,
        $next: String,
        $previous: String,
        $sortField: String,
        $status: [PaymentStatus!],
        $userId: [String!],
        $parentUserId: [String!],
        $from: DateTime,
        $to: DateTime,
        $category: [PaymentCategory!],
        $searchString: String,
        $current: Boolean,
        $pending: Boolean,
        $otherStatuses: [PaymentOtherStatuses!],
        $tags: [String!],
        $isManual: Boolean
        #$order: Float
      ) {
        invoices(
          limit: $limit,
          next: $next,
          previous: $previous,
          sortField: $sortField,
          status: $status, 
          userId: $userId,
          parentUserId: $parentUserId,
          from: $from,
          to: $to,
          category: $category,
          searchString: $searchString
          current: $current,
          pending: $pending,
          otherStatuses: $otherStatuses
          tagsId: $tags
          isManual: $isManual
          #order: $order
        ) {
            hasNext
            hasPrevious
            next
            previous
            totalDocs            
            docs {
                 ${paymentQueryResult}
            }
          }
        }`,
    {
      fetchPolicy: 'cache-first',
      variables: {
        ...query,
        category: [...new Set(query?.category?.map((category) => manualCategoryMap[category] || category))],
        status: (query?.status?.includes('pendingPayment') || query?.status?.includes('unPaid')) && !shortcuts.pending ? query.status.map((item) => filterForStatus[item]) : query?.status,
        ...(query?.category?.some((category) => manualTypes.includes(category)) ? { isManual: true } : {})
      }
    }
  )

  const setFilter = useCallback((newQuery) => {
    //REINICIA PAGINACIÓN
    setActivePage(1)
    if (isEqual(query, newQuery)) {
      refetch()
    } else {
      setQuery({
        ...newQuery,
        next: '', previous: ''
      })
    }
  }, [query, refetch])

  useEffect(() => {
    if (!effectiveParentUserId || studentsLoading || studentsError) return
    const selectedStudents = Array.isArray(selectedUserIds) ? selectedUserIds : []
    const validStudentIds = selectedStudents.filter((studentId) => {
      const student = statementStudents.find(({ id }) => id === studentId)
      return studentBelongsToParent(student, effectiveParentUserId)
    })
    if (!isEqual(selectedStudents, validStudentIds)) setFilter({ ...query, userId: validStudentIds })
  }, [effectiveParentUserId, statementStudents, studentsLoading, studentsError, query, selectedUserIds, setFilter])


  // const { data: dataTotal, loading: loadTotal } = useQuery(
  //   gql`query(
  //       $status: [PaymentStatus!],
  //       $userId: [String!],
  //       $parentUserId: [String!],
  //       $from: DateTime,
  //       $to: DateTime,
  //       $category: [PaymentCategory!],
  //       $searchString: String,
  //       $current: Boolean,
  //       $pending: Boolean,
  //       $otherStatuses: [PaymentOtherStatuses!]
  //       $tags: [String!]
  //     ) {
  //       totalInvoices(
  //         status: $status, 
  //         userId: $userId,
  //         parentUserId: $parentUserId,
  //         from: $from,
  //         to: $to,
  //         category: $category,
  //         searchString: $searchString
  //         current: $current,
  //         pending: $pending,
  //         otherStatuses: $otherStatuses
  //         tagsId: $tags
  //       ) {
  //           totalAmount
  //           totalStudents
  //         }
  //       }`,
  //   {
  //     fetchPolicy: 'cache-first',
  //     variables: { ...query, status: (query?.status?.includes('pendingPayment') || query?.status?.includes('unPaid')) && !shortcuts.pending ? query.status.map((item) => filterForStatus[item]) : query?.status },
  //   }
  // )

  const { data: dataProcessLater, refetch: refetchProcessLater } = useQuery(
    gql`query {
      invoicesWithProcessInvoiceLater {
        id
        status
        category
        from
        to
        processInVoiceLater {
          processDate
          kind
        }
      }
    }`,
    {
      fetchPolicy: 'cache-and-network'
    }
  )

  // const { totalAmount, totalStudents } = useMemo(
  //   () => {
  //     return dataTotal?.totalInvoices || {}
  //   }, [dataTotal]
  // )

  const {
    hasNext, hasPrevious, invoices,
    pageIndexPrevious, pageIndexNext, pageCount
  } = useMemo(
    () => {
      return {
        hasNext: data?.invoices?.hasNext || false,
        hasPrevious: data?.invoices?.hasPrevious || false,
        invoices: data?.invoices?.docs || [],
        pageIndexNext: data?.invoices?.next,
        pageIndexPrevious: data?.invoices?.previous,
        pageCount: Math.ceil((data?.invoices?.totalDocs || 0) / ((query?.limit || 10) || 1))
      }
      //eslint-disable-next-line
    }, [data, query?.limit]
  )
  const invoicesProcessInvoiceLater = useMemo(() => {
    return dataProcessLater?.invoicesWithProcessInvoiceLater?.filter(
      invoice => invoice?.processInVoiceLater?.processDate && moment(invoice?.processInVoiceLater?.processDate).tz(currentTimezone).isAfter(moment()) && invoice.status !== 'paid' && invoice?.processInVoiceLater?.kind === 'bulk'
    ) || []
    //eslint-disable-next-line
  }, [dataProcessLater])
  // Modal lista de mails
  const { open: openEmailsListModal } = useModalEmailsList()

  const viewInvoice = (item) => {
    dispatch({
      type: 'SET_DATA_MODAL_FORM_LIST',
      payload: 'payments.viewInvoice',
      data: {
        isOpen: true,
        invoiceId: item
      }
    })
  }
  const processInvoice = (item, multiple) => {
    dispatch({
      type: 'SET_DATA_MODAL_FORM_LIST',
      payload: 'payments.processInvoice',
      data: {
        isOpen: true,
        isMultiple: false,
        invoiceId: item
      }
    })
  }
  const processInvoices = () => {
    dispatch({
      type: 'SET_DATA_MODAL_FORM_LIST',
      payload: 'payments.processInvoice',
      data: {
        isOpen: true,
        isMultiple: true,
        invoiceId: ''
      }
    })
  }
  const openNewInvoice = () => {
    dispatch({
      type: 'SET_DATA_MODAL_FORM_LIST',
      payload: 'payments.newInvoice',
      data: { isOpen: true }
    })
  }
  const openNewPaymentItem = () => {
    dispatch({
      type: 'SET_DATA_MODAL_FORM_LIST',
      payload: 'payments.newPayment',
      data: { isOpen: true }
    })
  }
  const invoiceOptions = [
    {
      title: (
        <div className='d-flex align-items-center'>
          {invoicesProcessInvoiceLater?.length > 0 && (
            <IconTime size={16} className='mr-2' />
          )}
          <span>Process invoice</span>
        </div>
      ),
      onClick: processInvoices
    },
    { title: translate('users.actions.emails'), onClick: () => { openEmailsListModal(() => { }, { ...query, limit: 0 }, 'payments') } },
    {
      title: translate('misc.summaryInvoice.callToActionLabel') || 'Download Summary',
      onClick: () => {
        openSendSummaryEmail(() => { }, true)
      }
    },
  ]
  const getPymentMethod = (method) => {
    if (!method) {
      return ''
    }
    switch (method.kind) {
      case 'manual':
        return 'Manual'
      case 'creditCard':
        return 'Credit card'
      default:
        return ''
    }
  }
  const clickNext = () => {
    if (hasNext) {
      setActivePage(activePage + 1)
      setQuery({
        ...query,
        next: pageIndexNext,
        previous: ''
      })
    }
  }
  const clickPrevious = () => {
    if (hasPrevious) {
      setActivePage(activePage - 1)
      setQuery({
        ...query,
        next: '',
        previous: pageIndexPrevious
      })
    }
  }
  const changeSize = (limit) => {
    // setActivePage(1)
    setFilter({ ...query, limit })
  }
  const updateList = () => {
    //actuliza listado pero no paginación
    refetch()
  }
  const searchInput = (
    <div className='ml-auto flex-grow-1 flex-md-grow-0 d-flex align-items-center'>
      <InputGroup className='znk-card users-table-search-group flex-nowrap w-100 w-md-auto'>
        <form
          autoComplete='off'
          onSubmit={(e) => {
            e.preventDefault()
            e.stopPropagation()
            e.nativeEvent.stopImmediatePropagation()
          }}
        >
          <div className='d-flex flex-row position-relative users-table-search-wrapper'>
            <input
              placeholder='Search'
              className='znk-input users-table-search form-control'
              style={{ height: '35px' }}
              ref={searchRef}
              autoComplete='off'
              onChange={(e) => { setTxtSearch(e.target.value) }}
              onKeyUp={(e) => {
                const { key } = e
                e.stopPropagation()
                e.nativeEvent.stopImmediatePropagation()
                if (key === 'Enter') setFilter({ ...query, searchString: txtSearch })
              }}
              value={txtSearch}
            />
            <span className='addon users-table-search-icon' aria-hidden='true'>
              <IconSearch size={14} className='text-gray' />
            </span>
          </div>
        </form>
      </InputGroup>
      <div className='d-none d-md-flex'>
        <OptionsEmailsAndDownloads options={invoiceOptions} loading={false} />
      </div>
    </div>
  )
  if (!isPermited) {
    return <NoAuthorize />
  }
  return (
    <>
      <div
        className='col-12 col-md-12 px-md-6 px-lg-7'
      >
        <div className='container-fluid mt-2 mt-md-5 d-flex px-0 flex-column-reverse flex-md-row'>
          <div className='payments-tabs d-flex align-items-center flex-row flex-grow-1 mt-2 mt-md-0'>
            <span className={`tab-link nav-title h3 m-0 mr-3 font-weight-bold ${shortcuts.currentCicle ? 'active' : 'text-muted'}`} onClick={() => resetShortcuts()}>Current Cycle</span>
            <span className={`tab-link nav-title h3 mx-3 font-weight-bold ${shortcuts.pending ? 'active' : 'text-muted'}`} onClick={() => setCurrentShortcut('pending')}>Pending</span>
            {/* <span className={`h3 mx-3 font-weight-bold ${shortcuts.upcomming ? '' : 'text-muted'}`} onClick={() => setCurrentShortcut('upcomming')}>Upcoming</span> */}
            <span className={`tab-link nav-title h3 mx-3 font-weight-bold ${shortcuts.paidOut ? 'active' : 'text-muted'}`} onClick={() => setCurrentShortcut('paidOut')}>Paid</span>
            <span className={`tab-link nav-title h3 mx-3 font-weight-bold ${shortcuts.draft ? 'active' : 'text-muted'}`} onClick={() => setCurrentShortcut('draft')}>Draft</span>
            <span className={`tab-link nav-title h3 mx-3 font-weight-bold ${shortcuts.cancelled ? 'active' : 'text-muted'}`} onClick={() => setCurrentShortcut('cancelled')}>Cancelled</span>
            <span className={`tab-link nav-title h3 mx-3 font-weight-bold ${shortcuts.all ? 'active' : 'text-muted'}`} onClick={() => setCurrentShortcut('all')}>All invoices</span>
          </div>
          <div className='d-flex align-items-center justify-content-end justify-content-md-start flex-row-reverse flex-md-row'>
            {/* <ButtonEmailsList 
                      onClick={() => { openEmailsListModal(() => {}, {...query, limit: 0}, 'payments') }} 
            /> */}         
            <span>
              <StatementAccount
                query={query}
                students={statementStudents}
                studentsLoading={studentsLoading}
                studentsError={studentsError}
              />
            </span>
            <DropDownNew
              className='ml-3 py-2 pl-3'
              classNameMenu='p-0'
              direction='bottomRight'
              hoverEnabled={false}
              trigger={['click']}
              options={[
                {
                  component: (
                    <DropDownItem onClick={openNewInvoice}>
                      <span className='d-block px-0 py-0'>New Invoice</span>
                    </DropDownItem>
                  )
                },
                {
                  component: (
                    <DropDownItem onClick={openNewPaymentItem}>
                      <span className='d-block px-0 py-0'>New Invoice Item</span>
                    </DropDownItem>
                  )
                }
              ]}
            >
              <NewActionButton
                className='users-action-button py-0 px-2'
                style={{ width: '155px' }}
                label='New Invoice'
                endIcon={<IconArrowDown size={14} />}
              />
            </DropDownNew>
            <div className='d-md-none'>
              <OptionsEmailsAndDownloads options={invoiceOptions} loading={false} />
            </div>
          </div>
        </div>
        <div className='container-fluid mt-2 mt-md-4 d-flex flex-row justify-content-between px-0'>
          {
            breakWidth === 'SM' ?
              <>
                <ModalFilterMobile
                  setQuery={setFilter}
                  query={query}
                  onStudentsLoaded={setStudentState}
                  effectiveParentUserId={effectiveParentUserId}
                >
                  <div className='hover-icon'><IconFilter size={20} className='text-disabled' /></div>
                </ModalFilterMobile>
                {searchInput}
              </> :
              // <div className={'container-fluid m-0 p-0 d-flex flex-row flex-grow-1'}>
            <div className='container-fluid m-0 d-flex align-items-center px-0 znk-scroll-horizontal'>
                <ParentsFilter
                  {...{
                    parentFilters: query?.parentUserId,
                    setParentFilters: (parentUserId) => {
                      setFilter({
                        ...query, parentUserId
                      })
                    }
                  }}
                />
                <StudentsFilter
                  {...{
                    studentFilters: query?.userId,
                    setStudentFilters: (userId) => {
                      setFilter({
                        ...query, userId
                      })
                    },
                    onStudentsLoaded: setStudentState
                  }}
                />
                {!shortcuts.currentCicle && (
                  <StartDateFilter
                    startDateFilter={[query?.from, query?.to]}
                    setStartDateFilter={(startDateFilter) => {
                      const from = startDateFilter[0] !== undefined ? startDateFilter[0] : undefined
                      const to = startDateFilter[1] !== undefined ? startDateFilter[1] : undefined
                      setFilter({ ...query, from, to })

                    }}
                    typeFilter='Date'
                  />
                )}
                {(shortcuts.all || shortcuts.currentCicle || shortcuts.upcomming) &&
                  <StatusesFilter {...{
                    statuses: baseStatuses,
                    statusFilters: query?.status || [],
                    setStatusFilters: (status) => {
                      setFilter({
                        ...query, status
                      })
                    }
                  }} />
                }
                <TypesFilter {...{
                  types: baseTypes,
                  typesFilters: query?.category || [],
                  setTypesFilters: (category) => {
                    setFilter({ ...query, category })
                  }
                }} />
                <TagsFilter {...{
                  tags: baseTypes,
                  tagsFilters: query?.tags || [],
                  setTagsFilters: (tags) => {
                    setFilter({ ...query, tags })
                  }
                }} />
                <CreditsFilter
                  otherStatusesFilters={query?.otherStatuses || []}
                  setOtherStatusesFilters={(otherStatuses) => {
                    setFilter({
                      ...query, otherStatuses
                    })
                  }}
                />

                {
                  canReset(query)
                   ? <ResetFiltersButton className='align-self-center' onClick={resetFilters} />
                    : null
                }
                {searchInput}
              </div>
          }
          {/**<span className={'h45 text-gray'} onClick={() => {setOrder(changeOrder())}}>
              ORDER: {order === -1 ? 'ASC' : order === 1 ? 'DESC' : 'Default' }  
          </span>**/}
        </div>
        <div className='container-fluid d-flex flex-column mx-0 mt-4 px-0'>
          <TabContent activeTab={loadInvoices ? 'loading' : 'show'}>
            <TabPane tabId={`loading`}>
              <Skeleton style={{ borderRadius: '12px' }} className={`my-1`} count={query?.limit || 10} height={60} />
            </TabPane>
            <TabPane tabId={`show`}>
              {invoices.map(invoice => {
                const counselingWhite = invoice.category !== 'livePrep' && !['paid', 'unPaid', 'canceled'].includes(invoice.status)
                return (
                  <div
                    key={invoice.id}
                    className={`znk-invoice-row ${['paid', 'unPaid', 'canceled', 'draft'].includes(invoice.status) ? invoice.status : shortcuts.currentCicle ? invoice.category : 'upcomming'}`}
                  >
                    <span onClick={() => { }}>
                      {invoice.category === 'livePrep' ?
                        <IconLesson /> :
                        <IconStarActive className={counselingWhite && shortcuts.currentCicle ? 'text-white' : 'text-counseling'} />}
                      {/* <img src={`https://media.zinkerz.com/email/20210422/counseling${counselingWhite && shortcuts.currentCicle ? '-white' : ''}.png`} style={{height: 16, width: 16}} className='img-fluid' alt="counseling lesson" />} */}
                      <div style={{ marginLeft: 7 }}>{moment(invoice.to).format('MMMM YYYY')}{invoice.isManual ? ' (Manual)' : ''}</div>
                    </span>
                    <span className='font-weight-bold text-color' onClick={() => { viewInvoice(invoice.id) }}>${invoice.status === 'paid' ? formatNumber(invoice.amount) : invoice.amountPaid === 0 ? formatNumber(invoice.amount) : formatNumber(normalizeNumber(invoice.amountPaid))}</span>
                    <span className='text-color' onClick={() => { viewInvoice(invoice.id) }}>{invoice.user.firstName} {invoice.user.lastName}</span>
                    <span className='text-color opacity' onClick={() => { viewInvoice(invoice.id) }}>{getPymentMethod(invoice.user.paymentMethod)}</span>
                    <span className='text-color opacity justify-content-between' onClick={() => { viewInvoice(invoice.id) }}>
                      INV-{String(invoice.invoiceNumber).padStart(5, 0)}
                      {invoice.isRefunded && (<IconDolarRefresh className='mr-2' />)}
                      {invoice.hasNegativePayment && (<IconCircleDolar className='mr-2' />)}
                      {invoice.processInVoiceLater?.processDate && moment(invoice.processInVoiceLater.processDate).tz(currentTimezone).isAfter(moment().format()) && invoice.status !== 'paid' && (
                        <ToolTipInfo
                          tooltipId={`invoice-time-${invoice.id}`}
                          place='top'
                          innerElement={
                            <span>
                              {translate('payments.processpayment.programProcessInvoice.programFor')} {moment(invoice.processInVoiceLater.processDate).tz(currentTimezone).format('MM/DD/YYYY hh:mm a')}
                            </span>
                          }
                        >
                          <IconTime size={16} className='mr-2 text-gray' />
                        </ToolTipInfo>
                      )}
                    </span>
                    <span className=''>
                      {invoice.status === 'pendingPayment'
                        ? <DropDownNew
                          direction='bottomLeft'
                          // fixedWidth
                          // hoverEnabled={false}
                          options={[{
                            component:
                              <DropDownItem>
                                <span
                                  className='p-3'
                                  onClick={() => {
                                    viewInvoice(invoice.id)
                                  }}
                                >View invoice
                                </span>
                              </DropDownItem>
                          }, {
                            component:
                              <DropDownItem>
                                <span
                                  className='p-3'
                                  onClick={() => {
                                    processInvoice(invoice.id)
                                  }}
                                >Process invoice
                                </span>
                              </DropDownItem>
                          }, 
                          // {
                          //   component:
                          //     <DropDownItem>
                          //       <span
                          //         className='p-3'
                          //         onClick={() => {
                          //           copyInvoiceLink(invoice?.id)
                          //         }}
                          //       >{translate('payments.invoiceLink.text')}
                          //       </span>
                          //     </DropDownItem>
                          // }
                        ]}
                        >
                          <div className={`mr-1 hover-icon cursor-pointer`}>
                            <IconOptions style={{ transform: 'rotate(90deg)' }} color={`${(counselingWhite && shortcuts.currentCicle) || invoice.category === 'livePrep' ? 'white' : 'rgba(37, 64, 80, 0.6)'}`} />
                          </div>
                        </DropDownNew>
                        :
                        <div className={`mr-1 hover-icon cursor-not-allowed`}>
                          <IconOptions style={{ transform: 'rotate(90deg)' }} color={`${counselingWhite && shortcuts.currentCicle ? 'white' : 'rgba(37, 64, 80, 0.6)'}`} onClick={() => { viewInvoice(invoice.id) }} />
                        </div>}
                    </span>
                  </div>
                )
              })}
            </TabPane>
          </TabContent>
        </div>
        <NewInvoice refetch={updateList} />
        <NewPaymentItem refetch={updateList} />
        {isOpen && <ViewInvoice refetch={updateList} />}
        <ProcessInvoice refetch={updateList} invoicesWithProcessInvoiceLater={invoicesProcessInvoiceLater} refetchProcessLater={refetchProcessLater} />
        <EditInvoice refetch={updateList} />
      </div>
      <Pagination
        bottomFix
        className={`w-100 px-4 pt-7 d-flex flex-row justify-content-between align-items-center`}
        pageSize={query?.limit || 10}
        changeSize={changeSize}
        clickNext={clickNext}
        clickPrevious={clickPrevious}
        hasPrevious={hasPrevious}
        hasNext={hasNext}
        activePage={activePage}
        pageCount={pageCount}
        loading={loadInvoices}
        innerSection={
          isTotalPermited ?
            <TabContent className={`w-100`} activeTab={/*loadTotal ? 'loading' :*/ 'show'}>
              <TabPane
                className={`w-100`}
                tabId={'loading'}>
                <div className={`d-flex flex-row justify-content-end align-items-center px-2 pt-2 pb-2`}>
                  {
                    new Array(2).fill(0).map(
                      () => {
                        return (
                          <div className={`mx-2 d-flex flex-column align-items-center`}>
                            <Skeleton count={1}
                              width={50} height={12}
                            />
                            <Skeleton count={1}
                              width={70} height={12}
                            />
                          </div>
                        )
                      }
                    )
                  }
                </div>
              </TabPane>
              <TabPane
                className={`w-100`}
                tabId={'show'}>
                <div
                  className={`d-flex flex-row justify-content-end align-items-center px-2 pt-2 pb-2`}
                >
                  {/* <div className='d-flex flex-column align-items-center px-2'>
                    <span className={`h4 text-info font-weight-bold`}>Students</span>
                    <span className={`h4 text-gray`}>{totalStudents}</span>
                  </div>
                  <div className='d-flex flex-column align-items-center px-2'>
                    <span className={`h4 text-info font-weight-bold`}>Total</span>
                    <span className={`h4 text-gray`}>{`$${formatNumber(totalAmount)}`}</span>
                  </div> */}
                </div>
              </TabPane>
            </TabContent> : null
        }
      />
    </>
  )
}

export default PaymentsViews
